import { createStore, applyMiddleware, compose } from 'redux';
import { config } from 'hub-redux-auth';
import CleverTapHandler from './services/cleverTap';
import reducer from './reducers';
import cleverTapWare from './middlewares/cleverTapWare';
import AccountCreated from './components/AccountCreated';

CleverTapHandler.initialize();

/* eslint-disable no-underscore-dangle */
let initialState = {};

function createReduxStore(preloadedState, sagaMiddleware) {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  initialState = preloadedState;
  return window.__redux_store_dump = createStore(
    // preloadedState to pass intitial state in reducers
    reducer, preloadedState,
    composeEnhancers(applyMiddleware(sagaMiddleware, cleverTapWare))
  );
}

const
  clientId = process.env.HUB_CLIENT_ID,
  hubHost = process.env.HUB_HOST;

config.set('grantType', 'client_credentials');
config.set('clientId', clientId);
config.set('tokenScope', 'find_or_create send_sign_in_otp verify_sign_in_otp');
config.set('loginScope', 'send_verification_otp user_profile verify_verification_otp update_user_profile update_profile_restricted send_verification_link update_hub_applications');
config.set('loginRedirectUrl', '/manage_account');
config.set('createUserUrl', '/api/v1/user/create_user');
config.set('hubHost', hubHost);
config.set('cleverTap', CleverTapHandler);
config.set('tncURL', 'https://reseller.payu.in/raf_tnc');
config.set('accountCreatedComponent', AccountCreated);
config.set('skip_password_expired_screen', true);
config.set('referModal', true);
config.set('searchKeys', ['invite_token']);

config.set('prismicCmsHost', process.env.PRISMIC_CMS_HOST);
config.set('cmsAccessToken', process.env.CMS_ACCESS_TOKEN);
config.set('PRISMIC_DEFAULT_SIGNIN_DOC_ID', process.env.PRISMIC_DEFAULT_SIGNIN_DOC_ID);
config.set('PRISMIC_DEFAULT_SIGNUP_DOC_ID', process.env.PRISMIC_DEFAULT_SIGNUP_DOC_ID);
config.set('product', 'PARTNER');
config.set('PAYU_LOGO_IMG_URL', process.env.PAYU_LOGO_IMG_URL);
config.set('PAYU_WHITE_LOGO_IMG_URL', process.env.PAYU_WHITE_LOGO_IMG_URL);
/* eslint-enable */
export default createReduxStore;

